import React, { useState } from 'react';
import { Select, TextField, MenuItem } from '@mui/material';
import DisabledTextField from '../../DisabledTextField';
import ColumnHeader from '../../ColHeader';
import { RENTAL_TEXTILE_LAUNDRY } from '../../../constants';
import FormTable from '../../FormTable1/FormTable';
import DynamicOutputTable from '../../DynamicOutputTable';
import CustomAccordion from '../../CustomAccordion';
import CustomAlert from '../../Alert';
import ApiClient from '../../../apisClient';

const api = new ApiClient();

const FootprintAccordian = () => {
  const [visibleColumns, setVisibleColumns] = useState({
    input: true,
    input_1: true,
    input_2: false,
    input_3: false,
    input_4: false,
  });
  const [hiddenColumnsOrder, setHiddenColumnsOrder] = useState([]);
  const [averageMachineLoad, setAverageMachineLoad] = useState(Array(5).fill(250));
  const [incumbentFabricWeight, setIncumbentFabricWeight] = useState(["","","","",""]);
  const [outputVisibleColumns, setOutputVisibleColumns] = useState(visibleColumns);
  const [alertMessage, setAlertMessage] = useState(null);
  const [submittedData, setSubmittedData] = useState(null);
  const [percentage, setPercentage] = useState([]);
  const [isReset, setIsReset] = useState(false);

  const handleHideColumn = (column) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [column]: false,
    }));
    setHiddenColumnsOrder((prevState) => [...prevState, column]);
    // setIncumbentFabricWeight((prevState) => {
    //   const newState = [...prevState];
    //   newState[]  = undefined;
    //   return newState;
    // });

  };

  const handleShowColumn = (column) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [column]: true,
    }));
    setHiddenColumnsOrder((prevState) => prevState.filter(col => col !== column));
  };

  function getLastHiddenColumnName() {
    if (hiddenColumnsOrder.length === 0) {
      return null;
    }
    return hiddenColumnsOrder[hiddenColumnsOrder.length - 1];
  }

  const col = ["input", "input_1", "input_2", "input_3", "input_4"];
  const visibleColumnIds = col.filter((col) => visibleColumns[col]);
  const lastVisibleColumn = visibleColumnIds[visibleColumnIds.length - 1];
  const visibleColumnCount = visibleColumnIds.length;

  const handleIncumbentFabricWeight = (event, index) => {
    const value = event.target.value;
    setIncumbentFabricWeight((prevState) => {
      const newState = [...prevState];
      if (value === "" || !isNaN(value)) {
        newState[index] = value;
      }
      return newState;
    });
  };

  const isFormValid = () => {
    for (let i = 0; i < visibleColumnCount; i++) {
      if (isNaN(incumbentFabricWeight[i])) {
        setAlertMessage("Please enter valid fabric weight");
        return false;
      } else if (incumbentFabricWeight[i] === "") {
        setAlertMessage("Please enter fabric weight");
        return false;
      } else if (incumbentFabricWeight[i] < 0) {
        setAlertMessage("Please enter a positive number");
        return false;
      } else {
        setAlertMessage("");
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!isFormValid()) {
      return;
    }
    setIsReset(false);
    const payload = {
      i_fabric_weight: incumbentFabricWeight.filter((weight) => weight !== "").map(parseFloat),
    };
    try {
      const response = await api.post('/api/v1/operational-footprint', payload);
      const responseData = response;
      setOutputVisibleColumns(visibleColumns);
      setPercentage(responseData.output);
    } catch (error) {
      console.error("Fetch error:", error);
    }

    setSubmittedData(payload);
  };

  //handle reset
  const handleReset = () => {
    setIsReset(true);
    setIncumbentFabricWeight(["", "", "", "", ""]);
  };

  const Operational_footprint_rows = [
    {
      label: "",
      input: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[0]}
          onRemove={() => handleHideColumn("input")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input"}
          nextColumnId="input_1"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_1: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[1]}
          onRemove={() => handleHideColumn("input_1")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_1"}
          nextColumnId="input_2"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_2: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[2]}
          onRemove={() => handleHideColumn("input_2")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_2"}
          nextColumnId="input_3"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_3: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[3]}
          onRemove={() => handleHideColumn("input_3")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_3"}
          nextColumnId="input_4"
          visibleColumnCount={visibleColumnCount}
        />
      ),
      input_4: (
        <ColumnHeader
          headerText={RENTAL_TEXTILE_LAUNDRY.POTENTIAL_SAVINGS_HEADERS[4]}
          onRemove={() => handleHideColumn("input_4")}
          onShow={handleShowColumn}
          isLastVisible={lastVisibleColumn === "input_4"}
          nextColumnId={getLastHiddenColumnName()}
          visibleColumnCount={visibleColumnCount}
        />
      ),
    },
    {
      label: "Average Machine Load (kg):",
      input: (
        <DisabledTextField width={"140px"} value={averageMachineLoad[0]} />
      ),
      input_1: (
        <DisabledTextField width={"140px"} value={averageMachineLoad[1]} />
      ),
      input_2: (
        <DisabledTextField width={"140px"} value={averageMachineLoad[2]} />
      ),
      input_3: (
        <DisabledTextField width={"140px"} value={averageMachineLoad[3]} />
      ),
      input_4: (
        <DisabledTextField width={"140px"} value={averageMachineLoad[4]} />
      ),
    },
    {
      label: "Incumbent fabric weight (g/m²):",
      input: (
        <TextField
        select
        label="Select fabric weight"
        name="fabric_weight"
        size="small"
        sx={{ width: "100%", maxWidth: '140px' }}
        className="input-tf"
        value={incumbentFabricWeight[0]}
        align="left"
        onChange={(e) => handleIncumbentFabricWeight(e, 0)}
      >
        <MenuItem value="204">204 g/m²</MenuItem>
        <MenuItem value="224">224 g/m²</MenuItem>
      </TextField>

      ),
      input_1: (
        <TextField
          size="small"
          className="input-tf"
          placeholder="Enter fabric weight"
          value={incumbentFabricWeight[1]}
          onChange={(e) => handleIncumbentFabricWeight(e, 1)}
        />
      ),
      input_2: (
        <TextField
          size="small"
          className="input-tf"
          placeholder="Enter fabric weight"
          value={incumbentFabricWeight[2]}
          onChange={(e) => handleIncumbentFabricWeight(e, 2)}
        />
      ),
      input_3: (
        <TextField
          size="small"
          className="input-tf"
          placeholder="Enter fabric weight"
          value={incumbentFabricWeight[3]}
          onChange={(e) => handleIncumbentFabricWeight(e, 3)}
        />
      ),
      input_4: (
        <TextField  
          size="small"
          className="input-tf"
          placeholder="Enter fabric weight"
          value={incumbentFabricWeight[4]}
          onChange={(e) => handleIncumbentFabricWeight(e, 4)}
        />
      ),
    },
  ];

  const section_2 = [
    {
      title: "Operational footprint",
      content: (
        <>
          <p className="accordian-text">
            {RENTAL_TEXTILE_LAUNDRY.OPERATIONAL_FOOTPRINT_ACCORDIAN_TEXT}
            <br />
            <p className="accordian-text-bold">
              {RENTAL_TEXTILE_LAUNDRY.OPERATIONAL_FOOTPRINT_ACCORDIAN_TEXT_BOLD}
            </p>
          </p>
          <FormTable
            rows={Operational_footprint_rows}
            onSubmit={handleSubmit}
            onReset={handleReset}
            visibleColumns={visibleColumns}
            handleHideColumn={handleShowColumn}
          />
          {alertMessage && <CustomAlert text={alertMessage} />}
          {submittedData && !alertMessage && !isReset && (
            <DynamicOutputTable
              visibleColumns={outputVisibleColumns}
              title={"Operational footprint"}
              data={[
                {
                  label: "Average Machine Load (kg):",
                  value1: averageMachineLoad[0] || 0,
                  value2: averageMachineLoad[1] || 0,
                  value3: averageMachineLoad[2] || 0,
                  value4: averageMachineLoad[3] || 0,
                  value5: averageMachineLoad[4] || 0,
                },
                {
                  label: "Incumbent fabric weight (g/m²):",
                  value1: incumbentFabricWeight[0] || 0,
                  value2: incumbentFabricWeight[1] || 0,
                  value3: incumbentFabricWeight[2] || 0,
                  value4: incumbentFabricWeight[3] || 0,
                  value5: incumbentFabricWeight[4] || 0,
                },
                {
                  label: "Footprint percentage",
                  value1: percentage[0],
                  value2: percentage[1],
                  value3: percentage[2],
                  value4: percentage[3],
                  value5: percentage[4],
                },
              ]}
            />
          )}
        </>
      ),
    },
  ];

  return <CustomAccordion sections={section_2} />;
};

export default FootprintAccordian;